/**
 * Межа показника одометра (і пробігу Wialon) — як на бекенді (ShiftEntity::MAX_ODOMETER).
 * Більших показників в авто не буває; межа ловить зайву цифру при введенні.
 */
export const MAX_ODOMETER = 99_999_999
